import { udeskActionTypes as actions } from '~constants/actionTypes';
import { fetch } from '~actions/shared';
import endpoints from '~settings/endpoints';
import { formatSimpleParams } from '~helpers/params';
import * as queries from '~settings/queries';
import { Hosts } from '~helpers/environments';

const authorization = Hosts.udeskAuthen;

export const setStudentDetail = payload => ({
  type: actions.SET_STUDENT,
  payload,
});

export const setPartnerDetail = payload => ({
  type: actions.SET_PARTNER,
  payload,
});

export const getStudentDetailWithUsPhone = (payload, phone) => dispatch => {
  if (payload.getStudentDetails) {
    return dispatch(setStudentDetail(payload));
  }

  fetch({
    dispatch,
    endpoint: endpoints.getStudentDetail.url(),
    params: queries.studentDetail({
      phone: phone.replace('+86', '+'),
    }),
    headers: {
      Authorization: authorization,
    },
    communicationType: actions.GET_STUDENT_CS,
    successAction: setStudentDetail,
  });

  return true;
};

export const getStudentDetail = params => dispatch => {
  if (params.referrerEmail) {
    return dispatch(
      setPartnerDetail({
        referrerEmail: params.referrerEmail,
        referrerName: params.referrerName,
        partnerCode: params.partnerCode,
        partnerName: params.partnerName,
      }),
    );
  }

  let formattedPhone = params.phone || null;
  let phoneTrying = false;

  if (formattedPhone) {
    if (params.phone.length === 11 && params.phone[0] === '1') {
      formattedPhone = `+86${params.phone}`;
      phoneTrying = true;
    }

    if (formattedPhone[0] !== '(' && formattedPhone[0] !== '+') {
      formattedPhone = `+${params.phone}`;
    }
  }

  fetch({
    dispatch,
    endpoint: endpoints.getStudentDetail.url(),
    params: queries.studentDetail(
      formatSimpleParams(
        {
          userUuid: null,
          wechatId: null,
          phone: null,
        },
        {
          userUuid: params.userUuid,
          wechatId: params.wechatId,
          phone: formattedPhone,
        },
      ),
    ),
    headers: {
      Authorization: authorization,
    },
    communicationType: actions.GET_STUDENT_CS,
    successAction: phoneTrying
      ? payload => callbackDispatch => {
          callbackDispatch(getStudentDetailWithUsPhone(payload, formattedPhone));
        }
      : setStudentDetail,
  });
  return true;
};
